export default {
  "content": "<path d=\"M3 7.281l7 7.019 7-7.019L15.706 6 10 11.72 4.294 6 3 7.281z\" fill=\"#656A81\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};